import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'

import { WeScreen } from '@/components/WeScreen/WeScreen'
import { useUserInfoQuery } from '@/store/api/Users/Users.query'
import {
  updateProfileImage,
  updateUserName,
} from '@/store/api/Users/Users.slice'
import { trackOnboardingStepViewed, OnboardingSteps } from '@/utils/analytics'

import { PopupSearchForm } from './Components/PopupSearchForm'
import { SearchForm } from './Components/SearchForm'

export const SetupDigitalFootprint = () => {
  const dispatch = useDispatch()
  const hasTrackedView = useRef(false)
  const { data, isLoading: isLoadingUserInfo, isSuccess } = useUserInfoQuery()

  // Track step viewed once on mount
  useEffect(() => {
    if (!hasTrackedView.current) {
      trackOnboardingStepViewed(OnboardingSteps.DIGITAL_FOOTPRINT)
      hasTrackedView.current = true
    }
  }, [])

  useEffect(() => {
    if (data) {
      dispatch(updateProfileImage(data?.profilePicUrl || ''))
      dispatch(
        updateUserName({
          firstname: data?.firstname || '',
          lastname: data?.lastname || '',
        }),
      )
    }
  }, [isSuccess, data])

  return (
    <WeScreen
      customViewStyles="max-sm:p-0"
      useHeader={false}
      childrenCustomPadding={0}
      isLoading={isLoadingUserInfo}
    >
      <div className="flex flex-col h-full justify-between items-center max-lg:gap-4 w-full max-sm:w-full">
        <div className="flex flex-col lg:h-[80%] w-1/2 max-lg:w-full ">
          <PopupSearchForm />
          {data && <SearchForm currentData={data} />}
        </div>
      </div>
    </WeScreen>
  )
}
